export default __webpack_public_path__ + "static/media/ABChanelCorpo-Regular.3f93c183.woff";